export default {"src":"/_next/static/media/rating-2.5ac5a8ab.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};